import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v1/a/get-users';

class UsersEndPoint extends BaseEndpoint {
  file() {
    return this.client.$get(`${apiPath}`, {responseType: 'arraybuffer'});
  }
}

export default UsersEndPoint;